import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { analyticsTrack } from '../../../analyticsUtils';
import './PhoneNumberInput.scss';

class PhoneNumberInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: props.defaultValue,
    };

    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleUserOptInChange = this.handleUserOptInChange.bind(this);

    this.startEnteringPhone = false;
    this.userOptedInState = props.userOptedIn;
  }

  handlePhoneNumberChange(value) {
    if (value === '') {
      this.setState({ phone: null });
    }

    if (!this.startEnteringPhone) {
      this.startEnteringPhone = true;

      const { location } = this.props;
      if (location) {
        analyticsTrack('Phone Number Input', { location });
      }
    }
  }

  handleUserOptInChange() {
    this.userOptedInState = !this.userOptedInState;
    analyticsTrack('Opt In/Opt Out', { location, state: this.userOptedInState ? 'Checked' : 'Unchecked' });
  }

  renderOptInCheckbox() {
    const { userOptedIn } = this.props;

    return (
      <Fragment>
        <input type="hidden" name="user[opt_in]" value="false" />
        <label htmlFor="opt-in-input">
          <input
            id="opt-in-input"
            name="user[opt_in]"
            type="checkbox"
            className="mr-8"
            defaultChecked={userOptedIn}
            value="true"
            onChange={this.handleUserOptInChange}
          />
          I confirm that I want to receive SMS messages for critical hiring notifications.
          Message & data rates apply.
        </label>
      </Fragment>
    );
  }

  renderCopy() {
    const { cloraPhone } = this.props;

    return (
      <span className="body-text-3">
        Our records indicate that you have opted out of SMS notifications.
        To resume, please text
        {' '}
        <strong>START</strong>
        {' '}
        to
        {' '}
        <strong>{cloraPhone}</strong>
        .
        Msg & data rates apply.
      </span>
    );
  }

  render() {
    const { id, className, renderCheckbox } = this.props;
    const { phone } = this.state;

    return (
      <div id={id} className={className}>
        <div className="body-text-2">
          <div>
            Phone number (optional)&nbsp;
            <OverlayTrigger
              placement="right"
              delay={{ show: 100 }}
              overlay={(
                <Tooltip id="phone-number-tooltip">
                  We will use this information to notify you about candidates,
                  interviews, timesheets,
                  and other critical hiring communications.
                </Tooltip>
              )}
            >
              <i className="fas fa-info-circle" />
            </OverlayTrigger>
          </div>
          <div>
            <PhoneInput
              value={phone}
              country="us"
              preferredCountries={['us']}
              containerClass="phone-number-container"
              inputClass="phone-number-input"
              inputProps={{ name: 'user[phoneNumber]' }}
              onChange={this.handlePhoneNumberChange}
              countryCodeEditable={false}
            />
          </div>
          <div className="mt-16">
            { renderCheckbox ? this.renderOptInCheckbox() : this.renderCopy() }
          </div>
        </div>
      </div>
    );
  }
}

PhoneNumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  userOptedIn: PropTypes.bool,
  location: PropTypes.string,
  renderCheckbox: PropTypes.bool.isRequired,
  cloraPhone: PropTypes.string,
};

PhoneNumberInput.defaultProps = {
  className: '',
  defaultValue: '',
  userOptedIn: false,
  location: 'Location Not Specified',
  cloraPhone: '',
};

export default PhoneNumberInput;
